import { createStyles, makeStyles } from '@material-ui/core/styles';
export default makeStyles(() => createStyles({
  chooseAgreementRoot: {
    display: 'flex',
    width: '100%',
    textAlign: 'left',
    flexDirection: 'column'
  },
  alignLeft: {
    display: 'flex',
    justifyContent: 'flex-start'
  },
  newAgreement: {
    display: 'flex',
    flexDirection: 'column',
    '& subtitle1': {
      fontWeight: 'bold'
    },
    '& > div:first-child': {
      marginBottom: 0
    }
  }
}));